module.exports = __webpack_public_path__ + "static/media/trolleybus.2130a6f1.svg";